import * as React from "react";
import DateInput from "../DateInput/DateInput";
import { useField } from "react-final-form";
import { isBefore, isAfter, parseISO, isToday, isSameMonth, differenceInMonths } from "date-fns";
import { CardType } from "../../../types/LibraryCard";

interface Props {
	withEndDate?: boolean;
	forHistory?: boolean;
	dateBeginNameField: string;
	dateEndNameField: string;
	hideDay?: boolean;
}

const DatesWrapper: React.FunctionComponent<Props> = (props) => {
	const [hasErrors, setHasErrors] = React.useState(false);

	const startReading = useField(props.dateBeginNameField, {
		type: "input",
		validate: (value, allValues: any) => {
			if (
				value && 
				props.withEndDate &&
				allValues.hasOwnProperty(props.dateEndNameField)
			) {
				if (
					isAfter(parseISO(value), parseISO(allValues[props.dateEndNameField]))
				) {
					setHasErrors(true);

					return "Даты должны идти по порядку";
				}
			}

			if (!props.forHistory && value) {
				if (
					allValues["type"] === CardType.WantRead &&
						differenceInMonths(parseISO(value), new Date()) < 0
				) {
					return "Не получится запланировать в прошлом"
				}

				if (
					(allValues["type"] === CardType.AlreadyRead ||
						allValues["type"] === CardType.ReadNow) &&
					isAfter(parseISO(value), new Date())
				) {
					return "Дата должна быть в прошлом";
				}
			}

			setHasErrors(false);
		},
	});

	const finishReading = useField(props.dateEndNameField, {
		type: "input",
		validate: (value, allValues: any) => {
			if (
				value && 
				props.withEndDate &&
				allValues.hasOwnProperty(props.dateBeginNameField)
			) {
				if (
					isBefore(
						parseISO(value),
						parseISO(allValues[props.dateBeginNameField])
					)
				) {
					setHasErrors(true);

					return "Даты должны идти по порядку";
				}
			}

			setHasErrors(false);
		},
	});

	const error = startReading.meta.error || finishReading.meta.error;

	return (
		<>
			<div className="edit__datesWrapper">
				<div className="edit__datesWrapper__date">
					<div className="edit__datesWrapper__header">Начало чтения</div>

					<DateInput
						label="Начало чтения"
						name={startReading.input.name}
						onChange={startReading.input.onChange}
						onBlur={startReading.input.onBlur}
						error={!!error}
						openDate={
							startReading.input.value
								? parseISO(startReading.input.value)
								: null
						}
						defaultDate={
							startReading.input.value
								? parseISO(startReading.input.value)
								: new Date()
						}
						value={startReading.input.value}
						hideDay={props.hideDay}
					/>
				</div>
				{(props.withEndDate || props.forHistory) && (
					<div className="edit__datesWrapper__date">
						<div className="edit__datesWrapper__header">Окончание чтения</div>

						<DateInput
							label="Окончание чтения"
							name={finishReading.input.name}
							onChange={finishReading.input.onChange}
							onBlur={finishReading.input.onBlur}
							error={!!error}
							openDate={
								finishReading.input.value
									? parseISO(finishReading.input.value)
									: null
							}
							defaultDate={
								finishReading.input.value
									? parseISO(finishReading.input.value)
									: startReading.input.value
									? parseISO(startReading.input.value)
									: new Date()
							}
							value={finishReading.input.value}
						/>
					</div>
				)}
			</div>

			{error && (
				<div className="edit__section_hint edit__section_errorHint">
					{error}
				</div>
			)}
		</>
	);
};

export default DatesWrapper;
